'use client'
import {useTranslations} from 'next-intl';
import {useCommonDataContext} from '@/providers/CommonDataContext';
import Form from 'next/form';

export default function HeaderSearch({ contact }) {
  const t = useTranslations('header');
  const { common } = useCommonDataContext();
  return (
    <div className="col header-contact-serarch-column d-none d-lg-block">
      <div className="header-contact-search">
        {/* <!-- header-feature-item --> */}
        <div className="header-feature-item">
          <div className="header-feature-icon">
            <i className="icon-call"></i>
          </div>
          <div className="header-feature-info">
            <h6>{t('phone')}</h6>
            <p>
              <a href={`tel:${contact?.parsedTelNumber ?? common?.contact?.parsedTelNumber}`}>
                {contact?.telNumber ?? common?.contact?.telNumber}
              </a>
            </p>
          </div>
        </div>
        {/* <!-- header-search-2 --> */}
        <div className="header-search-2">
          <Form action="/catalog">
            <input
                type="text"
                name="search"
                placeholder={t('searchHere')}
            />
            <button type="submit">
              <span>
                <i className="icon-search"></i>
              </span>
            </button>
          </Form>
        </div>
      </div>
    </div>
  );
};
